import React, {useState} from 'react';
import {
  IFdProductionHistory,
  IFdProductionPlan,
  ISupplierUserProfile,
} from 'constants/interfaces';
import {reduxToggleSidePanel} from 'appredux/actions';
import {
  List,
  ListItem,
  ListItemText,
  Box,
  ListItemSecondaryAction,
  Button,
  Typography,
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import {ESidePanelView} from 'constants/index';
import {ProductionHistorySidePanelData} from 'screens/Dashboard/utils/SidePanel/SidePanel';

const EditFdProductionPlans = (props: {
  user: ISupplierUserProfile;
  applicationId: number;
  farmId: number;
  plans?: IFdProductionPlan[];
  history?: IFdProductionHistory[];
}) => {
  const [plans] = useState(props.plans || []);

  const handleEditPlan = (plan: IFdProductionPlan) => {
    const type = {
      panelType: ESidePanelView.EDIT_FD_PRODUCTION_PLAN,
      data: {
        applicationId: props.applicationId,
        plan,
      },
    };
    reduxToggleSidePanel(true, type, false);
  };

  const handleAdd = () => {
    const type = {
      panelType: ESidePanelView.EDIT_FD_PRODUCTION_PLAN,
      data: {
        applicationId: props.applicationId,
      },
    };
    reduxToggleSidePanel(true, type, false);
  };

  const handleEditHistory = (plan: IFdProductionPlan) => {
    const type = {
      panelType: ESidePanelView.EDIT_FD_PRODUCTION_HISTORY,
      data: {
        applicationId: props.applicationId,
        farmId: props.farmId,
        cropId: plan.crop!.id,
        cropName: plan.crop!.name,
        history: props.history,
      } as ProductionHistorySidePanelData,
    };
    reduxToggleSidePanel(true, type, false);
  };

  return (
    <Box margin={'1rem'}>
      <Box marginLeft={1}>
        <Typography variant="subtitle2" gutterBottom>
          Production Plans
        </Typography>
      </Box>
      <List>
        {plans.map((plan) => (
          <ListItem key={plan.id} button onClick={() => handleEditPlan(plan)}>
            <Box display="flex" justifyContent="space-between" width="100%">
              <ListItemText primary={plan.crop?.name} />
              <ListItemSecondaryAction>
                <ChevronRightIcon />
              </ListItemSecondaryAction>
            </Box>
          </ListItem>
        ))}
      </List>
      <Button variant="text" fullWidth onClick={handleAdd} color={'primary'}>
        Add
      </Button>
      <Box marginLeft={1} marginTop={2}>
        <Typography variant="subtitle2" gutterBottom>
          Production History
        </Typography>
      </Box>
      <List>
        {plans.map((plan) => (
          <ListItem
            key={plan.id}
            button
            onClick={() => handleEditHistory(plan)}
          >
            <Box display="flex" justifyContent="space-between" width="100%">
              <ListItemText primary={plan.crop?.name} />
              <ListItemSecondaryAction>
                <ChevronRightIcon />
              </ListItemSecondaryAction>
            </Box>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default EditFdProductionPlans;
